import { Button, ChevronRightSVG, Icon } from "@newsela/angelou";

import { actionNames, objectTypes, withTrackEvent } from "@newsela/snitch";
import { Assignment } from "@/types/models";
import {
  buttonCss,
  buttonDetailsCss,
  iconCss,
} from "./GeniusAssignmentOption.style";
import type { GenerationGeniusContent } from "@/view/GeniusContent/GeniusContent.interface";

interface GeniusAssignmentOptionProps {
  assignment: Assignment;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  content: GenerationGeniusContent;
}

const ButtonWithTrackEvent = withTrackEvent(Button);

const GeniusAssignmentOption = ({
  assignment,
  onClick,
  content,
}: GeniusAssignmentOptionProps) => {
  const hasClassrooms = assignment.assignment_classrooms?.length > 0;

  const teacherText = `Teacher: ${assignment.created_by?.user?.display_name}`;
  const classText = hasClassrooms
    ? `Class: ${assignment?.assignment_classrooms?.[0]?.classroom?.name}`
    : "";

  return (
    <ButtonWithTrackEvent
      flavor={Button.flavors.incognito}
      __cssFor={{
        root: buttonCss,
      }}
      onClick={onClick}
      dataProps={{
        "data-qa-selector": `generation-genius-assignment-option`,
      }}
      ariaProps={{
        "aria-label": `${assignment.title}. ${teacherText}. ${classText}. Open assignment activity panel`,
      }}
      objectType={objectTypes.content}
      actionName={actionNames.navigate}
      streamProperties={{
        content_type: "GenerationGeniusVideo",
        description: "Click Generations Genius assignment option",
        object_id: `${assignment.assignment_id}`,
        content_id: content.id,
      }}
    >
      <div css={buttonDetailsCss}>
        <div>{assignment.title}</div>
        <div>{teacherText}</div>
        {hasClassrooms ? classText : null}
      </div>
      <Icon
        __cssFor={{ root: iconCss }}
        SvgComponent={ChevronRightSVG}
        size={Icon.sizes.md}
      />
    </ButtonWithTrackEvent>
  );
};

export default GeniusAssignmentOption;
